import { Controller } from "@hotwired/stimulus"

import { MetaVars, show, hide } from "../lib/helpers"
import { StoredSetting } from "../lib/stored_setting"
import { triggerAction } from "../lib/helpers"
import { track } from "../lib/track_usage"
import { afterMorph } from "../lib/after_morph"

const CONDENSED_MODE_KEY = "condensed-mode"

export default class extends Controller {
  static targets = ["hideWhenCondensedOn"]

  connect() {
    this.setCondensedModeState()
    triggerAction()

    // Every save morphs the plan, which strips the d-none condensed mode added.
    this.stopAfterMorph = afterMorph(this.element, () => this.setCondensedModeState())
  }

  disconnect() {
    this.stopAfterMorph()
  }

  setCondensedModeState() {
    this.condensedModeEnabled ? this.condensedModeOn() : this.condensedModeOff()
  }

  // Content arriving after the toggle (e.g. lazy turbo frames) must pick up
  // the current condensed state, otherwise it stays visible in condensed mode.
  hideWhenCondensedOnTargetConnected(target) {
    if (this.condensedModeEnabled) hide(target)
  }

  get condensedModeEnabled() {
    return StoredSetting.get(CONDENSED_MODE_KEY, MetaVars.organizationId, { default: false }) === true
  }

  // `event` is only present when a user clicked the toggle — connect() calls
  // these too, and restoring saved state isn't a usage signal.
  condensedModeOn(event) {
    if (event) track("condensed_mode", { state: "on" })
    hide(this.hideWhenCondensedOnTargets)

    StoredSetting.set(CONDENSED_MODE_KEY, MetaVars.organizationId, true)
    hide("#condensed-mode-on")
    show("#condensed-mode-off, .plan-alerts #condensed-mode-alert-on")
  }

  condensedModeOff(event) {
    if (event) track("condensed_mode", { state: "off" })
    show(this.hideWhenCondensedOnTargets)

    StoredSetting.set(CONDENSED_MODE_KEY, MetaVars.organizationId, false)
    hide("#condensed-mode-off, .plan-alerts #condensed-mode-alert-on")
    show("#condensed-mode-on")
  }

  get elementsWithFocus() {
    return document.querySelectorAll("[focus_for*='[']")
  }
}